module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_07.6be082d8.jpg";